import * as yup from "yup";

export const validationSchema = yup.object().shape({
  vehicle_number: yup
    .string()
    .matches(
      /^[A-Z]{2}[0-9]{2}[A-Z]{1,2}[0-9]{4}$/,
      "Invalid vehicle number format (e.g., KA01AB1234)"
    ) // Matches common vehicle number format
    .required("Vehicle number is required"),

  licence_number: yup
    .string()
    .matches(
      /^[A-Z0-9\s]{10,20}$/,
      "Invalid licence number format (must be alphanumeric, allow spaces, 10-20 characters)"
    ) // Matches alphanumeric format with spaces, length 10-20
    .required("Licence number is required"),

  vehicle_details: yup
    .string()
    .required("Vehicle details are required") // Ensures vehicle details aren't empty
    .min(5, "Vehicle details must be at least 5 characters long") // Min length
    .max(100, "Vehicle details cannot exceed 100 characters"), // Max length

  licence_name: yup
    .string()
    .required("Licence name is required") // Ensure name is provided
    .min(3, "Licence name must be at least 3 characters") // Min length for name
    .max(50, "Licence name cannot exceed 50 characters"), // Max length for name

  address: yup
    .string()
    .required("Address is required") // Ensure address is provided
    .min(10, "Address must be at least 10 characters long") // Min length
    .max(200, "Address cannot exceed 200 characters"), // Max length
});
